<template>
  <div>
    <v-menu v-model="menu" :close-on-content-click="false" offset-y>
      <!-- Activator Button -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          height="25"
          max-height="25"
          outlined
          v-bind="attrs"
          v-on="on"
          style="
            border-color: #2196f3 !important;
            border-radius: 20px !important;
          "
        >
          <span class="blue--text">{{
            selectedStatus.text || "Select Status"
          }}</span>
          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <!-- Menu Items -->
      <v-list class="py-0">
        <v-list-item
          v-for="(item, index) in source"
          :key="index"
          @click="selectStatus(item)"
        >
          <v-list-item-avatar class="my-0 mx-0" v-if="item.color">
            <v-icon :color="item.color">mdi-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-0">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: Array,
      required: true,
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    selectedStatus: {
      get() {
        return this.selected;
      },
      set(val) {
        this.$emit("update:selected", val);
      },
    },
  },
  methods: {
    selectStatus(item) {
      this.selectedStatus = item; // triggers computed setter
      this.menu = false;
    },
  },
};
</script>
